module.exports = __webpack_public_path__ + "img/icon_solution.d2f90477.png";